import { useAdminPayments } from '../lib/queries.js';

export function PaymentsPage() {
  const { data, isLoading } = useAdminPayments();

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Pagamentos</h1>
      {isLoading && <div className="text-zinc-500">carregando…</div>}
      <div className="rounded-lg border border-zinc-800 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-xs uppercase text-zinc-500">
            <tr>
              <th className="text-left py-2 px-3">MP ID</th>
              <th className="text-left">Workspace</th>
              <th className="text-right">Valor</th>
              <th className="text-left">Método</th>
              <th className="text-left">Status</th>
              <th className="text-left">Quando</th>
            </tr>
          </thead>
          <tbody>
            {data?.payments.map((p) => (
              <tr key={p.id} className="border-t border-zinc-800/50">
                <td className="py-2 px-3 font-mono text-xs">{p.mpPaymentId}</td>
                <td className="font-mono text-xs">{p.workspaceId.slice(0, 8)}</td>
                <td className="text-right font-mono text-sm">
                  {p.currency} {(p.amount / 100).toFixed(2)}
                </td>
                <td className="text-xs">{p.method ?? '—'}</td>
                <td>
                  <span
                    className={`text-xs rounded px-1.5 py-0.5 ${
                      p.status === 'approved'
                        ? 'bg-emerald-950 text-emerald-400'
                        : p.status === 'rejected'
                          ? 'bg-rose-950 text-rose-400'
                          : 'bg-zinc-800 text-zinc-400'
                    }`}
                  >
                    {p.status}
                  </span>
                </td>
                <td className="text-xs text-zinc-500">
                  {new Date(p.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
            {data?.payments.length === 0 && (
              <tr>
                <td colSpan={6} className="py-6 text-center text-zinc-500">
                  nenhum pagamento ainda
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
